var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingContainer',{attrs:{"is-loaded":_vm.isLoaded,"total":_vm.subjectsLength,"kind":"Subjects"}},[_c('ul',{staticClass:"subject-picker",attrs:{"slot":"default"},slot:"default"},_vm._l((_vm.subjects),function(s){return _c('li',{key:s.id},[_c('ColorButton',{staticClass:"subject-picker__button",attrs:{"color":s.color,"tag":"router-link","to":{
          name: 'new-preset',
          params: {
            subjectId: s.id
          }
        }}},[_vm._v(" Log "),_c('b',[_vm._v(_vm._s(s.name))]),_vm._v(" Activity ")])],1)}),0),_c('router-link',{staticClass:"button button--border",attrs:{"slot":"button","to":{
      name: 'settings-subjects',
      query: {
        add: true
      }
    },"replace":""},slot:"button"},[_vm._v(" Add Subject ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }